import { missionCompletionSteps } from 'constants/mission';
import { CaseData, CaseState, EmbeddedMission } from 'ts/types/case.types';
import { ApplicationState } from '../reducers';

export const caseNamespaceSelector = (state: ApplicationState): CaseState =>
  state.case;

export const caseSelector = (state: ApplicationState): CaseData =>
  caseNamespaceSelector(state).data;

export const caseErrorSelector = (state: ApplicationState): any =>
  caseNamespaceSelector(state).error;

export const caseShortUrlSelector = (state: ApplicationState): string =>
  caseSelector(state)?.shortURL;

export const caseMissionsSelector = (
  state: ApplicationState,
): EmbeddedMission[] => caseSelector(state)?.embedded?.missionOrders || [];

export const completedCaseMissionsSelector = (
  state: ApplicationState,
): EmbeddedMission[] =>
  caseMissionsSelector(state).filter(({ step }) =>
    missionCompletionSteps.includes(step),
  );

export const pendingCaseMissionsSelector = (
  state: ApplicationState,
): EmbeddedMission[] =>
  caseMissionsSelector(state).filter(
    ({ step }) => !missionCompletionSteps.includes(step),
  );

export const countPendingCaseMissionsSelector = (
  state: ApplicationState,
): number => pendingCaseMissionsSelector(state).length;

export const countCompletedCaseMissionsSelector = (
  state: ApplicationState,
): number => completedCaseMissionsSelector(state).length;
